import { useEffect } from 'react';
import { useToast } from '../hooks/useToast';
import { UPDATE_AVAILABLE_EVENT } from '../updateReload';

/**
 * "Update available" while a new version waits for the next navigation (updateReload.ts): a page on a call,
 * uploading or editing is never reloaded under the person. Said once; the reload comes on the next page.
 */
export function UpdateAvailableToast() {
  const { showInfo } = useToast();
  useEffect(() => {
    let said = false;
    const say = () => { if (!said) { said = true; showInfo('Update available'); } };
    if ((window as unknown as { __dbUpdateAvailable?: boolean }).__dbUpdateAvailable) say();
    window.addEventListener(UPDATE_AVAILABLE_EVENT, say);
    return () => window.removeEventListener(UPDATE_AVAILABLE_EVENT, say);
  }, [showInfo]);
  return null;
}
